import useHandleActiveSpatialObject from './hooks/useHandleActiveSpatialObject';
import useHandleMessageCategory from './hooks/useHandleMessageCategory';
import useHandleTextFrom91FeatureMessages from './hooks/useHandleTextFrom911FeatureMessages';
import useHandleTranscriptionSummaries from './hooks/useHandleTranscriptionSummaries';
import useSpatialLayerIntersect from './hooks/useSpatialLayerIntersect';

/**
 * Empty component that contains hooks usage for Hermes callbacks
 */
const HermesCallbacks = () => {
  useHandleActiveSpatialObject();
  useSpatialLayerIntersect();
  useHandleTextFrom91FeatureMessages();
  useHandleMessageCategory();
  useHandleTranscriptionSummaries();

  return <></>;
};
export default HermesCallbacks;
